import * as React from "react";
import type { SVGProps } from "react";
const SvgCopy = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentColor"
      d="M5 16a1 1 0 1 0 0-2zm-3-3H1zM4 2V1zm9 0V1zm1 3a1 1 0 1 0 2 0zm-3 5h9V8h-9zm9 0a1 1 0 0 1 1 1h2a3 3 0 0 0-3-3zm1 1v9h2v-9zm0 9a1 1 0 0 1-1 1v2a3 3 0 0 0 3-3zm-1 1h-9v2h9zm-9 0a1 1 0 0 1-1-1H8a3 3 0 0 0 3 3zm-1-1v-9H8v9zm0-9a1 1 0 0 1 1-1V8a3 3 0 0 0-3 3zm-5 3H4v2h1zm-1 0a1 1 0 0 1-.707-.293l-1.414 1.414A3 3 0 0 0 4 16zm-.707-.293A1 1 0 0 1 3 13H1a3 3 0 0 0 .879 2.121zM3 13V4H1v9zm0-9a1 1 0 0 1 .293-.707L1.879 1.879A3 3 0 0 0 1 4zm.293-.707A1 1 0 0 1 4 3V1a3 3 0 0 0-2.121.879zM4 3h9V1H4zm9 0a1 1 0 0 1 .707.293l1.414-1.414A3 3 0 0 0 13 1zm.707.293A1 1 0 0 1 14 4h2a3 3 0 0 0-.879-2.121zM14 4v1h2V4z"
    />
  </svg>
);
export default SvgCopy;
